import { Component, Input } from '@angular/core';
/**
 * @hidden
 */
var StringFilterMenuInputComponent = /** @class */ (function () {
    function StringFilterMenuInputComponent() {
        this.operators = [];
    }
    StringFilterMenuInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kendo-grid-string-filter-menu-input',
                    template: "\n        <kendo-grid-filter-menu-input-wrapper\n            [column]=\"column\"\n            [filter]=\"filter\"\n            [operators]=\"operators\"\n            [defaultOperator]=\"operator\"\n            [currentFilter]=\"currentFilter\"\n            [filterService]=\"filterService\"\n            >\n            <input class=\"k-textbox\" kendoFilterInput [ngModel]=\"currentFilter?.value\" />\n        </kendo-grid-filter-menu-input-wrapper>\n    "
                },] },
    ];
    /** @nocollapse */
    StringFilterMenuInputComponent.ctorParameters = function () { return []; };
    StringFilterMenuInputComponent.propDecorators = {
        'operators': [{ type: Input },],
        'column': [{ type: Input },],
        'filter': [{ type: Input },],
        'operator': [{ type: Input },],
        'currentFilter': [{ type: Input },],
        'filterService': [{ type: Input },],
    };
    return StringFilterMenuInputComponent;
}());
export { StringFilterMenuInputComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/filtering/menu/string-filter-menu-input.component.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/filtering/menu/string-filter-menu-input.component.js
// module chunks = vendor